import * as THREE from 'three';

/**
 * Calculates the endpoint of a wall segment based on a starting point, rotation in degrees, and length.
 * Assumes rotation is in degrees around the Z-axis in a 2D plane (XY).
 *
 * @param startPoint - The starting position as a THREE.Vector3.
 * @param rotationsInRadians - The rotation in radians.
 * @param wallLength - The length of the wall segment.
 * @returns The calculated endpoint as a THREE.Vector3.
 */
export const calculateEndPoint = (startPoint: THREE.Vector3, rotationsInRadians: number, wallLength: number): THREE.Vector3 => {
  const endX = startPoint.x + Math.cos(rotationsInRadians) * wallLength;
  const endY = startPoint.y + Math.sin(rotationsInRadians) * wallLength;

  return new THREE.Vector3(endX, endY, 0);
};
